import React from "react";
import {
  useActionsHandOut,
  useHandOut,
} from "../../../../context/inventory/HandOutFormProvider";
const ListInventory = () => {
  const actions = useActionsHandOut();
  const state = useHandOut();
  const {
    movement: {
      inventory: { items },
    },
  } = state;
  return (
    <div className="col-md-6 col-lg-6 mt-4">
      <table className="col-md-6 col-lg-6 table table-default-app">
      <thead>
      <tr>
            <th scope="col">Referencia</th>
            <th scope="col">Nombre</th>
            <th scope="col">Tipo de medida</th>
            <th scope="col">Und. medida</th>
            <th scope="col">Cant. Consumida</th>
          </tr>
      </thead>
      <tbody>
        {items.map((item, i) => {
          return (
            <tr key={i}>
              <td>{item.lote}</td>
              <td>{item.abreviature}</td>
              <td>{item.stock}</td>
              <td>0</td>
              {/* <th>
              <FontAwesomeIcon
              className="cursor-pointer"
              icon={item.id ? faEraser : faSearch}
            />
              </th> */}
            </tr>
          );
        })}
      </tbody>
    </table>
    </div>
    
  );
};

export default ListInventory;
